import type { VersionedFetchOptions } from '@@/surface/api/fetchable_object'
import FetchableObject from '@@/surface/api/fetchable_object'
import { fetchJson } from '@@/surface/api_fetch'
import type { WhiteboardCardToolSettings, WhiteboardToolSettings } from '@@/types'
import type { JsonAPIResponse } from '@padlet/arvo'
import { HTTPMethod } from '@padlet/fetch'

interface WhiteboardCardToolSettingsPayload {
  sandbox: WhiteboardToolSettings
  cards: Record<string, { settings: WhiteboardToolSettings; resolved: WhiteboardToolSettings }>
}

const attributesOf = <T>(response: JsonAPIResponse<T>): T | undefined =>
  Array.isArray(response.data) ? response.data[0]?.attributes : response.data?.attributes

class WhiteboardCardToolSettingsApi extends FetchableObject {
  public static get url(): string {
    return `/api/\${ apiVersion }/walls/\${ wallHashid }/whiteboard/card-tool-settings`
  }

  public static async fetch(
    wallHashid: string,
    fetchOptions: VersionedFetchOptions = { apiVersion: 9 },
  ): Promise<WhiteboardCardToolSettings> {
    const { apiVersion, ...otherFetchOptions } = fetchOptions
    const response: JsonAPIResponse<WhiteboardCardToolSettingsPayload> = await fetchJson(
      this.buildUrl(this.url, { wallHashid, apiVersion }),
      { method: HTTPMethod.get, ...otherFetchOptions },
    )
    const payload = attributesOf(response)
    if (payload == null) throw new Error('Invalid response from server')
    return Object.fromEntries(
      Object.entries(payload.cards).map(([cardId, card]) => [cardId, { settings: card.settings }]),
    )
  }
}

export { WhiteboardCardToolSettingsApi }
